<template>
  <v-container>
    <div id="message-container">
      <div class="message-section">
        <div class="message-title">
          <h1 class="red--text">{{ getMessage.title }}</h1>
        </div>
        <h2>{{ getMessage.subtitle }}</h2>
        <p>{{ getMessage.text }}</p>
        <div>
          <v-btn outlined color="red" v-if="getMessage.extraBtn" @click="getMessage.extraBtn.btnClick">{{getMessage.extraBtn.btnTitle}}</v-btn>
          <v-btn outlined color="red" @click="onBtnClick">{{getMessage.btnTitle}}</v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "ErrorPage",
  computed: {
    getMessage() {
      return this.$store.getters.getErrorMessage;
    }
  },
  created() {
    if (
      typeof this.getMessage === "object" &&
      Object.keys(this.getMessage).length === 0
    ) {
      this.$router.push("/");
    }
  },
  methods: {
    onBtnClick() {
      if (
        this.getMessage.btnClick &&
        typeof this.getMessage.btnClick === "function"
      ) {
        this.getMessage.btnClick();
        return;
      } else {
        const logout_redirect_url =
        this.$store.getters.getConfig.oauth_authorization_url +
        "?response_type=code&client_id=" +
        this.$store.getters.getConfig.client_id +
        "&scope=profile&redirect_uri=" +
        this.$store.getters.getConfig.redirect_uri;
        const logOutUri =  this.$store.getters.getConfig.auth_logout_url +
        "?goto=" +
        encodeURIComponent(logout_redirect_url);
        this.$store.dispatch("setProgressBar", true);
        window.location = logOutUri;
      }
    }
  }
};
</script>

<style>
#message-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

#message-container .message-section {
  position: absolute;
  left: 50%;
  top: 42%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.message-section {
  max-width: 960px;
  width: 100%;
  line-height: 1.4;
  text-align: center;
  padding: 15px;
}

.message-section .message-title {
  position: relative;
  height: 150px;
}

.message-section .message-title h1 {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 50px;
  font-weight: 200;
  margin: 0px;
  background: linear-gradient(130deg, #ffa34f, #ff6f68);
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  text-transform: uppercase;
}

.message-section h2 {
  font-size: 27px;
  font-weight: 200;
  text-transform: uppercase;
  margin-top: 0px;
  margin-bottom: 15px;
}

.message-section p {
  font-size: 16px;
  font-weight: 200;
  margin-top: 0px;
  margin-bottom: 25px;
}

.message-section a {
  color: #ff6f68;
  font-weight: 200;
  text-decoration: none;
  border-bottom: 1px dashed #ff6f68;
  border-radius: 2px;
}

.message-section-social > a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  width: 40px;
  font-size: 14px;
  color: #ff6f68;
  border: 1px solid #efefef;
  border-radius: 50%;
  margin: 3px;
  -webkit-transition: 0.2s all;
  transition: 0.2s all;
}
.message-section-social > a:hover {
  color: #fff;
  background-color: #ff6f68;
  border-color: #ff6f68;
}

@media only screen and (max-width: 480px) {
  .message-section .message-title {
    position: relative;
    height: 168px;
  }

  .message-section .message-title h1 {
    font-size: 142px;
  }

  .message-section h2 {
    font-size: 22px;
  }
}
</style>
